export default __webpack_public_path__ + "static/media/regulatory--end-of-pedestrians-only--g4.74b84e48.png";